module.exports = __webpack_public_path__ + "img/BMerchantTransport64_ua.bf0d645e.webp";